<template>
  <div v-if="showSelector" class="theme-selector">
    <div v-if="switchSelector" class="items-flex ml-3">
      <v-icon :color="$vuetify.theme.dark ? 'white' : 'darkTextGrey'">
        mdi-weather-sunny
      </v-icon>
      <v-switch
        v-model="mySwitchValue"
        class="mx-1 my-0 py-0"
        :loading="loading"
        hide-details
        @change="toogleTheme"
      ></v-switch>
      <v-icon :color="$vuetify.theme.dark ? 'white' : 'darkTextGrey'">
        mdi-weather-night
      </v-icon>
    </div>
    <div v-else>
      <v-btn small text class="px-0" @click="toogleTheme">
        <v-icon
          v-if="!$vuetify.theme.dark"
          class="dark-icon"
          :color="$vuetify.theme.dark ? 'white' : 'darkTextGrey'"
        >
          mdi-weather-night
        </v-icon>
        <v-icon
          v-else
          size="22"
          class="sunny-icon"
          :color="$vuetify.theme.dark ? 'white' : 'darkTextGrey'"
        >
          mdi-weather-sunny
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    showSelector: {
      type: Boolean,
      default: true,
    },
    switchSelector: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mySwitchValue: null,
    }
  },
  computed: {
    ...mapState(['theme']),
  },
  mounted() {
    this.$vuetify.theme.dark = this.theme === 'dark'
    this.mySwitchValue = this.$vuetify.theme.dark
  },
  methods: {
    ...mapMutations({
      setTheme: 'SET_THEME',
    }),
    toogleTheme() {
      const myTheme = this.$vuetify.theme.dark ? 'light' : 'dark'
      this.setTheme(myTheme)
      this.$vuetify.theme.dark = myTheme === 'dark'
    },
  },
}
</script>

<style lang="scss">
.theme-selector {
  .items-flex {
    display: flex;
  }
  .theme-selector-text {
    text-transform: none;
    font-size: 12px;
    margin-bottom: 1px;
  }
}
</style>
